import { get, map } from 'lodash-es';
import { getPayload } from 'modules/api';

export const getCountriesPayload = (response) => {
  const payload = getPayload(response);
  return map(payload, (country) => get(country, 'name'));
};
